/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 261:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(210);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(184);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(262);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(267);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(193);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(272);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(273);
var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;



















;

var sectionType = 'main-page-producer-home';
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
var itemsPerPage = 20;
var totalPages = 0;
var selectors = {
  pageContainer: '.producer-home',
  pageGrid: '.producer-home--page-grid',
  alcoholFilter: 'producer-alcohol-dropdown',
  spiritsFilter: 'producer-spirits-dropdown',
  countryFilter: 'producer-country-dropdown',
  regionFilter: 'producer-region-dropdown',
  alcoholSelector: '.producer-alcohol-dropdown',
  spiritsSelector: '.producer-spirits-dropdown',
  countrySelector: '.producer-country-dropdown',
  regionSelector: '.producer-region-dropdown',
  paginationContainer: '.pagination-container'
};
var locale = {
  all_value: 'All'
};
var pageOnLoad;
var currentPageData = [];
var filteredResults = []; // Function to create and update pagination buttons

function updatePaginationButtons(currentPage) {
  var paginationContainer = document.querySelector(selectors.paginationContainer);
  paginationContainer.innerHTML = '';
  pageOnLoad = currentPage;

  if (totalPages > 1 && currentPage != 1) {
    var backButton = document.createElement('button');
    backButton.classList.add('pagination__prev-arrow');
    backButton.innerHTML = '<svg aria-label="Chevron left icon" class="icon icon-chevron-left" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15,6,9,12l6,6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/></svg>';
    backButton.addEventListener('click', function () {
      updatePaginationButtons(currentPage - 1);
      renderGrid(document, currentPage - 1);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    paginationContainer.appendChild(backButton);
  }

  var _loop = function _loop(i) {
    var button = document.createElement('button');
    button.innerText = i;
    button.classList.add('pagination-button'); // Highlight the current page button

    if (i == currentPage) {
      button.classList.add('active');
    } // Add click event to each button


    button.addEventListener('click', function () {
      updatePaginationButtons(i);
      renderGrid(document, i);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    paginationContainer.appendChild(button);
  };

  for (var i = 1; i <= totalPages; i++) {
    _loop(i);
  }

  if (totalPages > 1 && currentPage != totalPages) {
    var nextButton = document.createElement('button');
    nextButton.classList.add('pagination__next-arrow');
    nextButton.innerHTML = '<svg aria-label="Chevron right icon" class="icon icon-chevron-right" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9,18l6-6L9,6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/></svg>';
    nextButton.addEventListener('click', function () {
      updatePaginationButtons(currentPage + 1);
      renderGrid(document, currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    paginationContainer.appendChild(nextButton);
  }
}

var convertToEmbedArray = function convertToEmbedArray(sampleArr) {
  var _sampleArr$replace$re;

  return (_sampleArr$replace$re = sampleArr === null || sampleArr === void 0 ? void 0 : sampleArr.replace(/\[|\]/g, '').replace(/"/g, '').split(',')) !== null && _sampleArr$replace$re !== void 0 ? _sampleArr$replace$re : [];
};

function initFilter(container, currentUrl) {
  var alcoholValue = currentUrl.searchParams.get('alcohol');
  var spiritsValue = currentUrl.searchParams.get('spirits');
  var countryValue = currentUrl.searchParams.get('country');
  var regionValue = currentUrl.searchParams.get('region');
  container.querySelectorAll(".producer-home--page-filter").forEach(function (filter) {
    var selectFilterElement = filter.firstElementChild; // Create or update search parameters

    if (selectFilterElement.className == selectors.alcoholFilter) {
      var selectElement = document.querySelector(selectors.alcoholSelector);

      if (alcoholValue) {
        selectElement.value = alcoholValue;
      } else {
        selectElement.value = locale.all_value;
        currentUrl.searchParams.set('alcohol', locale.all_value);
      }
    }

    if (selectFilterElement.className == selectors.spiritsFilter) {
      var selectElement = document.querySelector(selectors.spiritsSelector);

      if (spiritsValue) {
        selectElement.value = spiritsValue;
      } else {
        selectElement.value = locale.all_value;
        currentUrl.searchParams.set('spirits', locale.all_value);
      }
    }

    if (selectFilterElement.className == selectors.countryFilter) {
      var selectElement = document.querySelector(selectors.countrySelector);

      if (countryValue) {
        selectElement.value = countryValue;
      } else {
        selectElement.value = locale.all_value;
        currentUrl.searchParams.set('country', locale.all_value);
      }
    }

    if (selectFilterElement.className == selectors.regionFilter) {
      var selectElement = document.querySelector(selectors.regionSelector);

      if (regionValue) {
        selectElement.value = regionValue;
      } else {
        selectElement.value = locale.all_value;
        currentUrl.searchParams.set('region', locale.all_value);
      }
    }
  }); // Replace the current URL with the updated one

  history.replaceState({}, '', currentUrl);
}

function resetHiddenFilters(filterType) {
  document.querySelectorAll(".producer-".concat(filterType, "-dropdown option")).forEach(function (opt, index) {
    if (index == 0) {
      opt.hidden = true;
    } else {
      opt.hidden = false;
    }
  });
}

function handleResize() {
  var screenWidth = window.innerWidth;

  if (screenWidth < 990) {
    itemsPerPage = 5;
    renderGrid(document, 1);
  } else itemsPerPage = 20;
}

function renderGrid(container, currentPage) {
  var data = " \n        {\n            pages(first: 250) {\n                edges {\n                    node {\n                        title\n                        handle\n                        vendor: metafield( namespace: \"custom\", key: \"vendor_collection\" ) {\n                            id\n                            namespace\n                            key\n                            value   \n                        }\n                        featuredImage: metafield(namespace: \"custom\", key: \"featured_image\" ) {\n                            reference {\n                                ... on MediaImage {\n                                image {\n                                    originalSrc\n                                }\n                                }\n                            }\n                        }\n                        country: metafield(namespace: \"filter\", key: \"country\" ) {\n                            id\n                            namespace\n                            key\n                            value  \n                        }\n                        region: metafield(namespace: \"filter\", key: \"region\" ) {\n                            id\n                            namespace\n                            key\n                            value  \n                        }\n                        alcohol: metafield(namespace: \"filter\", key: \"alcohol\" ) {\n                            id\n                            namespace\n                            key\n                            value  \n                        }\n                        spirits: metafield(namespace: \"filter\", key: \"spirit\" ) {\n                            id\n                            namespace\n                            key\n                            value  \n                        }\n                        \n                    }\n                }\n            }\n        }\n    "; // Create or update search parameters

  var currentUrl = new URL(window.location.href);
  var alcoholValue = currentUrl.searchParams.get('alcohol');
  var spiritsValue = currentUrl.searchParams.get('spirits');
  var countryValue = currentUrl.searchParams.get('country');
  var regionValue = currentUrl.searchParams.get('region');
  currentUrl.searchParams.set('page', currentPage);
  initFilter(container, currentUrl);
  var filterTypes = {
    alcohol: alcoholValue ? alcoholValue : 'All',
    spirits: spiritsValue ? spiritsValue : 'All',
    country: countryValue ? countryValue : 'All',
    region: regionValue ? regionValue : 'All'
  };
  var pageResults = [];
  var template = '';
  axios__WEBPACK_IMPORTED_MODULE_18__.default.post("https://".concat(Shopify.shop, "/api/graphql"), data, _utils_api__WEBPACK_IMPORTED_MODULE_16__.storefrontRequestConfig).then(function (response) {
    var alcoholQueue = new Map([['All', true]]);
    var spiritsQueue = new Map([['All', true]]);
    var countryQueue = new Map([['All', true]]);
    var regionQueue = new Map([['All', true]]);
    response.data.data.pages.edges.forEach(function (page) {
      var pushFilter = false;

      if (page.node.alcohol || page.node.spirits || page.node.country || page.node.region) {
        for (var _i = 0, _Object$keys = Object.keys(filterTypes); _i < _Object$keys.length; _i++) {
          var filter = _Object$keys[_i];

          if (filterTypes[filter] == locale.all_value) {
            pushFilter = true;
          } else {
            if (filter == 'alcohol') {
              if (page.node.alcohol && convertToEmbedArray(page.node.alcohol.value) == filterTypes[filter]) {
                pushFilter = true;
              } else {
                pushFilter = false;
                break;
              }
            }

            if (filter == 'spirits') {
              if (page.node.spirits && convertToEmbedArray(page.node.spirits.value) == filterTypes[filter]) {
                pushFilter = true;
              } else {
                pushFilter = false;
                break;
              }
            }

            if (filter == 'country') {
              if (page.node.country && convertToEmbedArray(page.node.country.value) == filterTypes[filter]) {
                pushFilter = true;
              } else {
                pushFilter = false;
                break;
              }
            }

            if (filter == 'region') {
              if (page.node.region && convertToEmbedArray(page.node.region.value) == filterTypes[filter]) {
                pushFilter = true;
              } else {
                pushFilter = false;
                break;
              }
            }
          }
        }

        if (pushFilter) {
          pageResults.push(page.node);

          if (page.node.alcohol) {
            alcoholQueue.set(page.node.alcohol.value, true);
          }

          if (page.node.spirits) {
            spiritsQueue.set(page.node.spirits.value, true);
          }

          if (page.node.country) {
            countryQueue.set(page.node.country.value, true);
          }

          if (page.node.region) {
            regionQueue.set(page.node.region.value, true);
          }
        }

        document.querySelectorAll(".producer-spirits-dropdown option").forEach(function (opt) {
          if (!spiritsQueue.has(opt.value) && spiritsQueue.size > 1 || alcoholValue == 'Wine') {
            if (opt.text == "All") {
              opt.disabled = false;
              opt.classList.remove("hideOption");
            } else {
              opt.disabled = true;
              opt.classList.add("hideOption");
            }
          } else {
            if (opt.text != "Spirits Type") {
              opt.disabled = false;
              opt.classList.remove("hideOption");
            }
          }
        });
        document.querySelectorAll(".producer-alcohol-dropdown option").forEach(function (opt) {
          if (!alcoholQueue.has(opt.value) && alcoholQueue.size > 1) {
            opt.disabled = true;
            opt.classList.add("hideOption");
          } else {
            if (opt.text != "Wines & Spirits") {
              opt.disabled = false;
              opt.classList.remove("hideOption");
            }
          }
        });
        document.querySelectorAll(".producer-country-dropdown option").forEach(function (opt) {
          if (!countryQueue.has(opt.value) && countryQueue.size > 1) {
            opt.disabled = true;
            opt.classList.add("hideOption");
          } else {
            if (opt.text != "Country") {
              opt.disabled = false;
              opt.classList.remove("hideOption");
            }
          }
        });
        document.querySelectorAll(".producer-region-dropdown option").forEach(function (opt) {
          if (!regionQueue.has(opt.value) && regionQueue.size > 1) {
            opt.disabled = true;
            opt.classList.add("hideOption");
          } else {
            if (opt.text != "Region") {
              opt.disabled = false;
              opt.classList.remove("hideOption");
            }
          }
        });
      }
    });
  })["catch"](function (error) {
    console.log(error);
    throw error;
  }).then(function () {
    filteredResults = pageResults;
    totalPages = Math.ceil(pageResults.length / itemsPerPage);
    pageResults.sort(function (a, b) {
      var textA = a.title.toUpperCase();
      var textB = b.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    var start = (currentPage - 1) * itemsPerPage;
    var end = start + itemsPerPage;
    currentPageData = pageResults.slice(start, end);
    currentPageData.forEach(function (page) {
      if (page.featuredImage) {
        var base_url = "".concat(window.location.origin, "/pages/").concat(page.handle);
        var newItem = "\n                <div class=\"producer-home--page-grid-card\"> \n                    <a href=\"".concat(base_url, "\"> \n                        <img href=\"").concat(base_url, "\" src=\"").concat(page.featuredImage.reference.image.originalSrc, "\">  \n                    </a>\n\n                    <div class=\"producer-home--page-grid-card-title-container\">\n                        <div class=\"producer-home--page-grid-card-title\">\n                            <a href=\"").concat(base_url, "\"> \n                                ").concat(page.title, "\n                            </a>\n                        </div> \n                        <div class=\"producer-home--page-grid-card-location\"> ").concat(page.country == null ? '' : page.country.value).concat(page.region == null ? '' : ', ' + page.region.value, " \n                            <a href=\"").concat(base_url, "\"> \n                                <svg class=\"producer-home--page-grid-card-arrow\"  aria-label=\"Chevron right icon\" class=\"icon icon-chevron-right\" width=\"6\" height=\"3\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9,18l6-6L9,6\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\"/></svg>\n                            </a>\n                        </div> \n                    </div>\n                </div>");
        template = template + newItem;
      } else {
        var base_url = "".concat(window.location.origin, "/pages/").concat(page.handle);

        var _newItem = "\n                <div class=\"producer-home--page-grid-card\"> \n                    <a href=\"".concat(base_url, "\"> \n                        <svg class=\"component-image__image placeholder-svg placeholder-image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 525.5 525.5\">\n                            <path d=\"M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z\" />\n                            <path d=\"M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z\" />\n                            <path d=\"M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z\" />\n                        </svg>\n                    </a>\n                    <div class=\"producer-home--page-grid-card-title-container\">\n                        <div class=\"producer-home--page-grid-card-title\">                    \n                            <a href=\"").concat(base_url, "\"> \n                            ").concat(page.title, "\n                            </a>\n                        </div> \n                        <div class=\"producer-home--page-grid-card-location\"> ").concat(page.country == null ? '' : page.country.value).concat(page.region == null ? '' : ', ' + page.region.value, " \n                            <a href=\"").concat(base_url, "\"> \n                                <svg class=\"producer-home--page-grid-card-arrow\"  aria-label=\"Chevron right icon\" class=\"icon icon-chevron-right\" width=\"6\" height=\"3\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9,18l6-6L9,6\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\"/></svg>\n                            </a>\n                        </div> \n                    </div>\n                </div>");

        template = template + _newItem;
      }
    });
  }).then(function () {
    totalPages = Math.ceil(pageResults.length / itemsPerPage);
    var currentUrl = new URL(window.location.href);
    var pageValue = currentUrl.searchParams.get('page');
    updatePaginationButtons(parseInt(pageValue));
    container.querySelector(selectors.pageGrid).innerHTML = template;
    var gridHeight = 150;
    var gridLength = 5;

    if (currentPageData.length <= itemsPerPage / 5) {
      gridHeight = 40;
      gridLength = 1;
    } else if (currentPageData.length <= itemsPerPage / 5 * 2) {
      gridHeight = 75;
      gridLength = 2;
    } else if (currentPageData.length <= itemsPerPage / 5 * 3) {
      gridHeight = 115;
      gridLength = 3;
    } else if (currentPageData.length <= itemsPerPage / 5 * 4) {
      gridHeight = 145;
      gridLength = 4;
    } else {
      gridHeight = 5;
    }

    container.querySelector(selectors.pageGrid).style.height = "".concat(gridHeight, "vh");
    container.querySelector(selectors.pageGrid).style.gridTemplateRows = "repeat(".concat(gridLength, ",minmax(0,1fr))");
  });
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_17__.register)(sectionType, {
  onLoad: function onLoad() {
    var screenWidth = window.innerWidth;

    if (screenWidth < 990) {
      itemsPerPage = 5;
    } else itemsPerPage = 20;

    var mainContainer = this.container;
    var currentUrl = new URL(window.location.href);
    var pageValue = currentUrl.searchParams.get('page');

    if (pageValue == null) {
      currentUrl.searchParams.set('page', 1);
      renderGrid(mainContainer, 1);
    } else {
      renderGrid(mainContainer, pageValue);
    }

    mainContainer.querySelectorAll(".producer-home--page-filter").forEach(function (filter) {
      filter.addEventListener("change", function (event) {
        // Display the selected value (you can modify this part based on your requirement)
        var currentUrl = new URL(window.location.href); // Create or update search parameters

        if (event.srcElement.className == selectors.alcoholFilter) {
          currentUrl.searchParams.set('alcohol', event.target.value);
        }

        if (event.srcElement.className == selectors.spiritsFilter) {
          currentUrl.searchParams.set('spirits', event.target.value);
        }

        if (event.srcElement.className == selectors.countryFilter) {
          currentUrl.searchParams.set('country', event.target.value);
        }

        if (event.srcElement.className == selectors.regionFilter) {
          currentUrl.searchParams.set('region', event.target.value);
        } // Replace the current URL with the updated one


        history.replaceState({}, '', currentUrl);
        renderGrid(mainContainer, 1);
      });
    });
    mainContainer.querySelectorAll(".producer-home--page--filter-reset").forEach(function (reset) {
      return reset.addEventListener("click", function () {
        // Display the selected value (you can modify this part based on your requirement)
        var currentUrl = new URL(window.location.href); // Create or update search parameters

        currentUrl.searchParams.set('alcohol', locale.all_value);
        currentUrl.searchParams.set('spirits', locale.all_value);
        currentUrl.searchParams.set('country', locale.all_value);
        currentUrl.searchParams.set('region', locale.all_value); // Replace the current URL with the updated one

        history.replaceState({}, '', currentUrl);
        pageOnLoad = 1;
        renderGrid(mainContainer, pageOnLoad);
      });
    });
    document.addEventListener('touchstart', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    });
  }
}));

/***/ }),

/***/ 272:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "apiEndpoint": () => (/* binding */ apiEndpoint),
/* harmony export */   "storefrontRequestConfig": () => (/* binding */ storefrontRequestConfig),
/* harmony export */   "xhrRequestConfig": () => (/* binding */ xhrRequestConfig)
/* harmony export */ });
// Details for Storefront API.
var storefrontAccessToken = {
  ifw: '4bc6c32d309733663e1b4eb619f15b7e',
  bib: '280882b68a5af50e8175ad86ba440d78'
};
var apiEndPoints = {
  bib: 'https://bibendum-wine-co.myshopify.com',
  ifw: 'https://ifw-production.myshopify.com'
};

function getApiEndPoint() {
  return Shopify.shop == 'bibendum-wine-co.myshopify.com' ? apiEndPoints.dev : apiEndPoints.prod;
}

var apiEndpoint = getApiEndPoint();

function getAccessToken() {
  return Shopify.shop == 'bibendum-wine-co.myshopify.com' ? storefrontAccessToken.bib : storefrontAccessToken.ifw;
}

var storefrontRequestConfig = {
  headers: {
    'Content-Type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': getAccessToken()
  }
}; // XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header

var xhrRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			30: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(261)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;